import { render, staticRenderFns } from "./asset.vue?vue&type=template&id=4c61bbae&scoped=true&"
import script from "./asset.vue?vue&type=script&lang=js&"
export * from "./asset.vue?vue&type=script&lang=js&"
import style0 from "./asset.vue?vue&type=style&index=0&id=4c61bbae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c61bbae",
  null
  
)

export default component.exports